/**
 * Checks if current route is bus|ferry search results
 */
export default function isCurrentRouteSearchResults() {
    return window.currentRoute.includes("front_slug_search_results")
}